import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root',
})
export class ServiceWorkerUpdateService {
  constructor(private swUpdate: SwUpdate) {
    if (swUpdate.isEnabled) {
      // Check for updates every 30 seconds
      setInterval(() => {
        swUpdate.checkForUpdate();
      }, 30000);

      // Handle available updates
      swUpdate.versionUpdates.subscribe((event) => {
        switch (event.type) {
          case 'VERSION_DETECTED':
            console.log('New version detected:', event.version);
            break;
          case 'VERSION_READY':
            console.log('New version ready:', event.latestVersion);
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.error('Failed to install new version:', event.error);
            break;
        }
      });

      // Handle unrecoverable state
      swUpdate.unrecoverable.subscribe((event) => {
        console.error('Service worker in unrecoverable state:', event.reason);
        this.reloadPage();
      });
    }
  }

  private activateUpdate() {
    this.swUpdate.activateUpdate().then(() => {
      this.reloadPage();
    });
  }

  private reloadPage() {
    window.location.reload();
  }

  // Force check for updates (can be called manually)
  checkForUpdate() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.checkForUpdate();
    }
  }

  // Force update (can be called manually)
  forceUpdate() {
    if (this.swUpdate.isEnabled) {
      this.activateUpdate();
    }
  }
}
